"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.anOkoConfirm = anOkoConfirm;
exports.anOkoUnsub = anOkoUnsub;
exports.changeCommunicationType = changeCommunicationType;
exports.changeCommunicationTypeByContractAccount = changeCommunicationTypeByContractAccount;
exports.changeCommunicationTypeForMultipleAccounts = changeCommunicationTypeForMultipleAccounts;
exports.default = anOkoSubscr;
exports.prefillOko = prefillOko;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _RestHelper = _interopRequireDefault(require("../utils/RestHelper"));
var _myDataApi = require("../../api-factory/myDataApi");
// eslint-disable-next-line import/no-unresolved

function anOkoSubscr(payload) {
  return _RestHelper.default.post("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/communication/v0/public/subscription"), payload, {}, false, false);
}
function changeCommunicationTypeByContractAccount(_x) {
  return _changeCommunicationTypeByContractAccount.apply(this, arguments);
}
function _changeCommunicationTypeByContractAccount() {
  _changeCommunicationTypeByContractAccount = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee2(notificationTypesNotFiltered) {
    var type,
      contractAccountCommunicationChanges,
      _args2 = arguments;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            type = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 'EMAIL';
            _context2.prev = 1;
            contractAccountCommunicationChanges = notificationTypesNotFiltered.map(/*#__PURE__*/function () {
              var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(notificationItem) {
                var contractAccountId, personalData, putPersonalData;
                return _regenerator.default.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        contractAccountId = notificationItem.contractAccountId;
                        _context.next = 3;
                        return (0, _myDataApi.getMyData)(contractAccountId);
                      case 3:
                        personalData = _context.sent;
                        personalData = personalData.data;
                        personalData.notificationTypeBill = personalData.notificationTypeBill ? type : null;
                        personalData.notificationTypeKSA = personalData.ksaNotification ? type : null;
                        _context.next = 9;
                        return _RestHelper.default.put("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/partner/v0/mydata/").concat(contractAccountId), personalData);
                      case 9:
                        putPersonalData = _context.sent;
                        return _context.abrupt("return", putPersonalData);
                      case 11:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));
              return function (_x3) {
                return _ref2.apply(this, arguments);
              };
            }());
            _context2.next = 5;
            return Promise.all(contractAccountCommunicationChanges);
          case 5:
            return _context2.abrupt("return", _context2.sent);
          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](1);
            return _context2.abrupt("return", false);
          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 8]]);
  }));
  return _changeCommunicationTypeByContractAccount.apply(this, arguments);
}
function anOkoConfirm(payload) {
  return _RestHelper.default.patch("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/communication/v0/public/subscription?").concat(new URLSearchParams(Object.entries(payload)).toString()), null, {}, false, false);
}
function anOkoUnsub(payload) {
  return _RestHelper.default.delete("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/communication/v0/public/subscription"), payload, {}, false, false);
}
function prefillOko(_ref) {
  var companyCode = _ref.companyCode,
    subscriptionInvitationId = _ref.subscriptionInvitationId;
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/communication/v0/public/subscriptionInvitation?companyCode=").concat(companyCode, "&subscriptionInvitationId=").concat(subscriptionInvitationId));
}
function changeCommunicationTypeForMultipleAccounts() {
  return _changeCommunicationTypeForMultipleAccounts.apply(this, arguments);
}
function _changeCommunicationTypeForMultipleAccounts() {
  _changeCommunicationTypeForMultipleAccounts = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee3() {
    var type,
      payload,
      _args3 = arguments;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            type = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : 'EMAIL';
            payload = {
              notificationType: {
                correspondence: type,
                selfReadingByCustomer: type
              }
            };
            return _context3.abrupt("return", _RestHelper.default.patch("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/partner/v0/mydata/notificationtypes"), payload, {}, false, false));
          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _changeCommunicationTypeForMultipleAccounts.apply(this, arguments);
}
function changeCommunicationType(_x2) {
  return _changeCommunicationType.apply(this, arguments);
}
function _changeCommunicationType() {
  _changeCommunicationType = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee4(contractAccountId) {
    var type,
      personalData,
      _args4 = arguments;
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            type = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : 'EMAIL';
            _context4.prev = 1;
            _context4.next = 4;
            return (0, _myDataApi.getMyData)(contractAccountId);
          case 4:
            personalData = _context4.sent;
            personalData = personalData.data;
            personalData.notificationTypeBill = personalData.notificationTypeBill ? type : null;
            personalData.notificationTypeKSA = personalData.ksaNotification ? type : null;
            return _context4.abrupt("return", _RestHelper.default.put("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/partner/v0/mydata/").concat(contractAccountId), personalData));
          case 11:
            _context4.prev = 11;
            _context4.t0 = _context4["catch"](1);
            return _context4.abrupt("return", false);
          case 14:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[1, 11]]);
  }));
  return _changeCommunicationType.apply(this, arguments);
}